import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCameraIconSecondary from './svgs/CameraIconSecondary.js';
import SvgCameraIcon from './svgs/CameraIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cameraIcon = (props => useIcon(SvgCameraIcon, SvgCameraIconSecondary, props));

export { cameraIcon as default };
